import ReactSelect from 'react-select';

interface StrongSingleSelectProps {
    options: { label: string; value: string }[];
    value?: { label: string; value: string } | { label: string; value: string }[];
    onSelectChange?: (selected: string) => void;
    isDisabled?: boolean;
}

const StrongSingleSelect: React.FC<StrongSingleSelectProps> = ({options, value, onSelectChange, ...props }) => {
    const handleChange = (selected: { label: string; value: string } | null) => {
        if (onSelectChange && selected) {
            onSelectChange(selected.value);
        }
    };

    const selectValue = Array.isArray(value)
        ? (value.length > 0 ? value[0] : null)
        : value;

    return (
        <ReactSelect
            options={options}
            value={selectValue}
            isSearchable={true}
            placeholder="Search..."
            onChange={(selected) => handleChange(selected as { label: string; value: string } | null)}
            {...props}
        />
    );
};

export default StrongSingleSelect;